import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AxiosResponse } from 'axios'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { ExtensionConnectionType } from '../types'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'

/**
 * Creates a connect Url to redirect to the to the IDP of the specified tariff vendor
 */
export const createVendorConnectionUrl = async (
  installationId: string,
  vendor: ExtensionConnectionType,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<{ url: string }>> => {
  const fetchProps = {
    path: `tariffs/${installationId}/vendor/vendor-link/connection`,
    method: 'POST',
    payload: { vendor },
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
  } as FetchProps

  const response: AxiosResponse<{ url: string }, unknown> = await authFetch(fetchProps)

  if (response.status === StatusCodes.OK) {
    return new ApiResult(response.data, false)
  }

  return new ApiResult<{ url: string }>(null, true)
}

/**
 * Confirm the connection to the specified tariff vendor.
 */
export const confirmVendorConnection = async (
  authFetch: AuthFetchWithResponse,
  installationId?: string,
  vendorAccountId?: string
): Promise<ApiResult<boolean | Error | AuthFetchError>> => {
  if (!installationId || !vendorAccountId) {
    return new ApiResult<boolean>(null, true)
  }
  try {
    const fetchProps = {
      path: `tariffs/${installationId}/vendor/vendor-link`,
      method: 'POST',
      payload: { vendorAccountId },
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    } as FetchProps

    const response: AxiosResponse<boolean, unknown> = await authFetch(fetchProps)

    if (response.status === StatusCodes.CREATED) {
      return new ApiResult<boolean>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}

/**
 * Delete the connection to the specified tariff vendor
 */
export const deleteVendorConnection = async (
  installationId: string,
  vendorName: ExtensionConnectionType,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  const response = await authFetch<string>({
    path: `tariffs/${installationId}/vendor/vendor-link`,
    method: 'DELETE',
    payload: { vendor: vendorName },
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<boolean, Error | AuthFetchError>(true)
  }

  return new ApiResult<boolean, Error | AuthFetchError>(null, true)
}
